import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/salefavour/list', qs.stringify(params))
}

export const getTemplate = () => {
  return axios.get(root + '/set/salefavour/getTemplate', null)
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/salefavour/remove', qs.stringify(params))
}

export const deletePricegroup = (params) => {
  return axios.post(root + '/set/salefavour/removePricegroup', qs.stringify(params))
}

export const updateSimple = (params) => {
  return axios.post(root + '/set/salefavour/updateSimple', qs.stringify(params))
}
//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/set/salefavour/detail', {params: params})
}

export const detailPricegroup = (params) => {
  return axios.get(root + '/set/salefavour/detailPricegroup', {params: params})
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/salefavour/update', qs.stringify(params))
    // return axios.post(root+'/set/employee/update', params,{headers:{"Content-Type":"application/json"}})

  } else {//添加
    return axios.post(root + '/set/salefavour/save', qs.stringify(params))
  }
}

export const savePricegroup= (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/salefavour/updatePricegroup', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/set/salefavour/savePricegroup', qs.stringify(params))
  }
}

export const saveSaleCommission= (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/salefavour/updateSaleCommission', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/set/salefavour/saveSaleCommission', qs.stringify(params))
  }
}

//获取下拉框、单选按钮的绑定数据
export const getControlData = () => {
  return axios.post(root + '/set/salefavour/getcontroldata')
}

//获取下拉框优惠方式
export const getCouponWay = () => {
  return axios.post(root + '/set/salefavour/getCouponWay')
}

//获取下拉框优惠方式
export const getCouponRule = () => {
  return axios.post(root + '/set/salefavour/getCouponRule')
}
//优惠规则
export const getFavourType = () => {
  return axios.post(root + '/set/salefavour/getFavourType')
}
//商品折扣、商品分类折扣复制
export const copyData = (params) => {
  return axios.post(root + '/set/salefavour/copyDiscount',qs.stringify(params))
}

export const listgoodsParamsitem = (params) => {
  return axios.post(root + '/set/salefavour/listgoodsParamsitem',qs.stringify(params))
}

export const listgoodsParams = (params) => {
  return axios.post(root + '/set/salefavour/listgoodsParams',qs.stringify(params))
}

export const savegoodsParams = (params) => {
  return axios.post(root + '/set/salefavour/savegoodsParams',qs.stringify(params))
}









// WEBPACK FOOTER //
// ./src/api/set/salefavour.js